<script setup>
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAppStore } from '../store/app';
import { returndate } from '../common/methods';
import TransactionHistory from '@/components/TransactionHistory.vue';

const store = useAppStore();
const route = useRoute();

/**
 * Fetch customer detail
 */
onMounted(() => {
  store.fetchCustomerDetails(route.params);
  store.customerTransactionsHistory = [];
  store.fetchCustomerTransactionHistory(route.params);
});
</script>

<script>
// normal `<script>`, executed in module scope (only once)
// declare additional options
export default {
  inheritAttrs: false,
  customOptions: {},
};
</script>

<template noInheritAttrs>
  <div>
    <v-card class="pa-4">
      <v-row>
        <v-col>
          <div>
            <strong> Name: </strong>
            {{ store.customerDetails?.firstName }} {{ store.customerDetails?.lastName }}
          </div>
        </v-col>
        <v-col class="d-flex align-center">
          <strong>Email: </strong>
          <p class="ml-2">{{ store.customerDetails?.email }}</p>
        </v-col>
        <v-col>
          <div><strong>Member ID: </strong>{{ store?.customerDetails?.memberId }}</div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <div>
            <strong> Subscription Type: </strong>
            {{ store?.customerDetails?.subscriptionName }}
          </div>
        </v-col>
        <v-col cols="4">
          <div>
            <strong> Member Since: </strong>
            {{ returndate({ date: store?.customerDetails?.subscriptionStartDate }) }}
          </div>
        </v-col>
      </v-row>
    </v-card>
    <TransactionHistory
      class="mt-4"
      v-if="store.customerDetails?.subscriptionId"></TransactionHistory>
  </div>
</template>
